// extracted by mini-css-extract-plugin
export var column = "TwoColumnLayout-module--column--VXaS6";
export var twoColumnLayout = "TwoColumnLayout-module--two-column-layout--RXoZG";